import { initializeFirebaseApp } from "../firebase";
import "./App.css";
import GlobalContextProvider from "./GlobalContext";
import Router from "./Router";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "simplebar-react/dist/simplebar.min.css";

// import { setLogLevel } from "@livekit/components-react";

initializeFirebaseApp();

function App() {
  // setLogLevel("debug");
  return (
    <>
      <GlobalContextProvider>
        <ToastContainer
          position="top-center"
          theme="dark"
          hideProgressBar={true}
          autoClose={3000}
          icon={false}
          bodyStyle={{ margin: 0, padding: 0, height: "100%" }}
        />
        <Router />
      </GlobalContextProvider>
    </>
  );
}

export default App;
